import { confirmationOfRecord, errorActions } from "@/alerts";
import axios from "../../../api";

const isVoucherConfigurationError = (detail) => {
  if (!detail || typeof detail !== "string") {
    return false;
  }

  const lowerDetail = detail.toLowerCase();
  const stockKeywords =
    /stock|saldo|kardex|almacen|inventario|insuficiente|cantidad_de_saldo/i;
  const voucherKeywords =
    /comprobante|duplicado|secuencia|serie|lote|vencid|expirad|ncf|factura/i;

  if (stockKeywords.test(lowerDetail)) {
    return false;
  }

  return voucherKeywords.test(lowerDetail);
};
/**
 * Funcion para insertar una venta
 * @param {*} data Los datos principales de la venta
 * @param {*} details Los detalles de la venta
 * @param {*} dataCustomer Los datos del cliente
 * @param {*} insurerData Los datos de la aseguradora
 * @param {*} orderQuotesTemporarySalesInfo el id de cotizaciones, pedidos y ventas temporales
 * @param {*} creditNote biene la informacion de la nota de credito cuando se aplica a una venta
 * @returns El id de la venta registrada
 */
export const insertSale = async (
  data,
  details,
  dataCustomer,
  insurerData,
  orderQuotesTemporarySalesInfo,
  creditNote,
) => {
  const {
    idUser,
    idStore,
    idTurn,
    idVoucher,
    idTypeOfSale,
    idTypeOfPayment,
    idCreditNote,
    total,
    totalWhitDiscount,
    igv,
    subTotal,
    otherDiscounts,
    totalCreditNote,
    totalCreditNoteDiference,
    discount,
    expireQuotation,
    comentary,
    totalPayableByInsurer,
    totalPayableByCustomer,
    userName,
    customerName,
    serieVoucher,
    numberVoucher,
    numberReference,
    currencyDescription,
    currencyPrefix,
    igvApplied,
    retention,
    entityBank,
    numberOperation,
    cashAmount,
    targetAmount,
    transferAmount,
    chequeAmount,
    customerAmountPaid,
    customerAmountReturned,
    modificationDate,
    sunatAnswer,
    paymentDate,
    initialFee,
    idCharge,
    nameCharge,
    codigo_pedido,
  } = data;
  try {
    const response = await axios.post(
      "ventas",
      {
        idUser,
        idStore,
        idTurn,
        idVoucher,
        idTypeOfSale,
        idTypeOfPayment,
        idCreditNote,
        total,
        totalWhitDiscount,
        igv,
        subTotal,
        otherDiscounts,
        totalCreditNote,
        totalCreditNoteDiference,
        discount,
        expireQuotation,
        comentary,
        totalPayableByInsurer,
        totalPayableByCustomer,
        userName,
        customerName,
        serieVoucher,
        numberVoucher,
        numberReference,
        currencyDescription,
        currencyPrefix,
        igvApplied,
        retention,
        entityBank,
        numberOperation,
        cashAmount,
        targetAmount,
        transferAmount,
        chequeAmount,
        customerAmountPaid,
        customerAmountReturned,
        modificationDate,
        sunatAnswer,
        state: idTypeOfSale == 2 ? "VENTA A CREDITO" : "EFECTUADA",
        idCustomer: dataCustomer.id,
        paymentDate,
        initialFee,
        idInsurer: insurerData.id,
        idOrder: orderQuotesTemporarySalesInfo.id,
        amountCreditNote: creditNote.amount,
        idCharge,
        nameCharge,
        details,
        codigo_pedido,
      },
      {
        method: {
          "Content-Type": "application/json",
        },
      },
    );
    const data = await response.data;

    const invoiceSigned = data.signedInvoice;

    if (data.msg === true) {
      confirmationOfRecord(
        `La venta del cliente <strong>${customerName}</strong>`,
        {
          timer: 1100,
          showConfirmButton: false,
        },
      );
      return {
        id: data.id,
        invoiceSigned,
        numberVoucher: data.numberVoucher,
        serieVoucher: data.serieVoucher,
      };
    } else {
      errorActions(
        `Lo sentimos no pudimos registrar la venta del cliente <strong>${customerName}</strong> verifica si tuviste alguna problemas al momento de ingresar los productos o los datos del cliente`,
      );
    }
    return {
      id: 0,
      invoiceSigned: null,
      numberVoucher: null,
      serieVoucher: null,
    };
  } catch (error) {
    const detail = error?.response?.data?.detail;

    if (detail) {
      const message = isVoucherConfigurationError(detail)
        ? `<strong>${detail}</strong>, verifica que tu número de comprobante esté bien configurado`
        : `<strong>${detail}</strong>`;

      errorActions(message);
    } else {
      errorActions(error);
    }
    return {
      id: 0,
      invoiceSigned: null,
      numberVoucher: null,
      serieVoucher: null,
    };
  }
};
